export const createUserLog = async (dadosLog) => {
  try {
    const token = localStorage.getItem('token');
    
    // Prepare log data with all required fields
    const logPayload = {
      id_usuario: dadosLog.id_usuario,
      componente: dadosLog.componente,
      acao: dadosLog.acao,
      caminho: dadosLog.caminho || window.location.pathname,
      ip_address: dadosLog.ip_address || 'não disponível',
      navegador: dadosLog.navegador || navigator.userAgent,
      id_sessao: dadosLog.id_sessao || localStorage.getItem('idSessao'),
      detalhes: dadosLog.detalhes || ''
    };

    const response = await fetch('https://api.fatcat.app.br/log/addLog', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(logPayload)
    });
    
    if (!response.ok) throw new Error('Falha ao criar log');
    return await response.json();
  } catch (error) {
    console.error('Erro ao criar log:', error);
    // Não propagar o erro para não interromper o fluxo da aplicação
    return null;
  }
};

export const buscarLogsUsuario = async (idUsuario) => {
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(`https://api.fatcat.app.br/log/userlogs/${idUsuario}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    
    if (!response.ok) throw new Error('Falha ao buscar logs');
    return await response.json();
  } catch (error) {
    console.error('Erro ao buscar logs:', error);
    return [];
  }
};